export default __webpack_public_path__ + "images/228a859eaedb1918cdd0e16629503302-valentine_dating_tablet.webp";